__turbopack_context__.v({
  "freeBox": "PlasmicAiChat-module__Oq8Epq__freeBox",
  "root": "PlasmicAiChat-module__Oq8Epq__root",
  "svg": "PlasmicAiChat-module__Oq8Epq__svg",
  "v0ChatPanel": "PlasmicAiChat-module__Oq8Epq__v0ChatPanel",
});
